import * as React from 'react';
import { Typography } from '@mui/material';

interface DocNotFoundProps {}

const DocNotFound: React.FC<DocNotFoundProps> = () => {
  return (
    <div style={{ margin: '4em 0' }}>
      <Typography variant="h4" align="center">
        Document Not Found
      </Typography>
      <Typography variant="subtitle1" align="center">
        The document you've requested no longer exists in our system. This is most likely because a
        user has deleted the document or the document has been removed due to our document retention
        policy.
      </Typography>
    </div>
  );
};

export default DocNotFound;
